(function(){
  var el = document.querySelector('[data-yv-seq]');
  if (!el) return;
  var sheets = JSON.parse(el.getAttribute('data-sprites'));
  var cols = parseInt(el.getAttribute('data-cols') || '4', 10);
  var per = parseInt(el.getAttribute('data-per') || '12', 10);
  var n = parseInt(el.getAttribute('data-count') || '24', 10);
  var canvas = el.querySelector('canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var turns = parseFloat(el.getAttribute('data-turns') || '1');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur = -1, scrollPos = 0, dragOff = 0, fw = 0, fh = 0;
  function draw(){
    var i = Math.round(scrollPos + dragOff);
    i = ((i % n) + n) % n;
    if (i === cur || !fw) return;
    var im = imgs[Math.floor(i / per)];
    if (!im || !im.complete || !im.naturalWidth) return;
    cur = i;
    var j = i % per;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(im, (j % cols) * fw, Math.floor(j / cols) * fh, fw, fh, 0, 0, canvas.width, canvas.height);
  }
  function ready(){
    var im = imgs[0];
    if (!im.complete || !im.naturalWidth) return;
    if (!fw){
      fw = im.naturalWidth / cols;
      fh = im.naturalHeight / Math.ceil(per / cols);
      canvas.width = fw;
      canvas.height = fh;
    }
    draw();
  }
  var imgs = sheets.map(function(u){
    var im = new Image();
    im.decoding = 'async';
    im.onload = ready;
    im.src = u;
    return im;
  });
  var tick = false;
  window.addEventListener('scroll', function(){
    if (reduce) return;
    if (tick) return;
    tick = true;
    requestAnimationFrame(function(){
      tick = false;
      var sec = el.closest('section') || el.parentElement;
      var range = Math.max(sec.offsetHeight, window.innerHeight * 0.8);
      var p = Math.min(Math.max(window.scrollY / range, 0), 1);
      scrollPos = p * n * turns;
      draw();
    });
  }, {passive: true});
  var px = null;
  el.addEventListener('pointerdown', function(e){ px = e.clientX; try{ el.setPointerCapture(e.pointerId); }catch(_){} });
  el.addEventListener('pointermove', function(e){
    if (px === null) return;
    dragOff -= (e.clientX - px) / 14;
    px = e.clientX;
    draw();
  });
  el.addEventListener('pointerup', function(){ px = null; });
  el.addEventListener('pointercancel', function(){ px = null; });
})();
